<template>
  <div>
    <div class="marg">
      <div con-filter ref="searchBox">
        <el-form
          :inline="true"
          size="mini"
          class="demo-form-inline"
          label-width="90px"
          @submit.native.prevent
          @keyup.enter.native="search"
        >
          <!-- <el-form-item label="项目名称" class="project_Width">
            <el-input
              placeholder="请输入"
              v-model="tikulist.ProjectName"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="筛选号">
            <el-input
              placeholder="请输入"
              v-model="tikulist.ScreenCode"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="中心名称" class="project_Width">
            <el-input
              placeholder="请输入"
              v-model="tikulist.CenterName"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="中心区域">
            <el-cascader
              ref="cascader"
              clearable
              v-model="tikulist.RegionName"
              :props="PropsCenterKey"
              :options="treeDatas"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="筛选状态">
            <el-select
              v-model="tikulist.ScreenType"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in optionsKnow"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="知情时间">
            <el-date-picker
              v-model="beginDate"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              @change="BEdate"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="入组时间">
            <el-date-picker
              v-model="beginDate1"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              @change="dateGroup"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="筛败时间">
            <el-date-picker
              v-model="beginDate2"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              @change="dateSieve"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label class="margBtn">
            <template>
              <el-button
                type="primary"
                size="mini"
                @click="search"
                :disabled="loadingUp"
                >查询</el-button
              >
              <el-button
                type="success"
                size="mini"
                @click="exportCRCCenterList"
                :loading="exportLoading"
                >导出</el-button
              >
            </template>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="table">
      <el-table
        :data="tikudata"
        size="mini"
        border
        v-loading="loadingUp" 
      >
        <el-table-column show-overflow-tooltip
          prop="ProjectName"
          label="项目名称"
          
          sortable
          min-width="200px"
          fixed="left"
        ></el-table-column>
        <el-table-column show-overflow-tooltip prop="CenterCode" label="中心编码"></el-table-column>
        <el-table-column show-overflow-tooltip
          prop="CenterName"
          label="中心名称"
          
          sortable
          min-width="200px"
        ></el-table-column>
        <el-table-column show-overflow-tooltip
          prop="Sponsor"
          label="申办方"
          min-width="120px"
          
        ></el-table-column>
        <el-table-column show-overflow-tooltip prop="PM" label="项目经理"></el-table-column>
        <el-table-column show-overflow-tooltip
          prop="ProjectDepartment"
          label="项目部门"
        ></el-table-column>
        <!-- <el-table-column show-overflow-tooltip prop="ProjectOffices" label="项目科室"></el-table-column> -->
        <el-table-column show-overflow-tooltip prop="ProjectType" label="项目类型"></el-table-column>
        <el-table-column show-overflow-tooltip
          prop="Indications"
          label="适应症"
          min-width="120px"
          
        ></el-table-column>
        <el-table-column show-overflow-tooltip prop="Ownership" label="项目归属"></el-table-column>
        <el-table-column show-overflow-tooltip
          prop="CRC"
          label="CRC"
          
        ></el-table-column>
        <el-table-column show-overflow-tooltip prop="ProjectLevel" label="项目级别"></el-table-column>
        <el-table-column show-overflow-tooltip
          prop="UserName"
          label="患者简称"
          
        ></el-table-column>
        <el-table-column show-overflow-tooltip
          prop="ScreenCode"
          label="筛选号"
          
        ></el-table-column>
        <el-table-column show-overflow-tooltip
          prop="ScreenDate"
          label="筛选日期"
          min-width="88px"
        ></el-table-column>
        <el-table-column show-overflow-tooltip prop="ScreenTimes" label="筛选工时"></el-table-column>
        <el-table-column show-overflow-tooltip prop="RandomCode" label="随机号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="Department" label="中心科室"></el-table-column>
        <!-- <el-table-column show-overflow-tooltip prop="RecDoctor" label="推荐医生"></el-table-column> -->
        <el-table-column show-overflow-tooltip prop="IsOut" label="是否招募推荐"></el-table-column>
        <!-- <el-table-column show-overflow-tooltip prop="OutCenter" label="外推中心"></el-table-column> -->
        <!-- <el-table-column show-overflow-tooltip
          prop="OutDepartment"
          label="外推科室"
        ></el-table-column> -->
        <el-table-column show-overflow-tooltip
          prop="Comments"
          label="备注"
          
          min-width="100px"
        ></el-table-column>
        <el-table-column show-overflow-tooltip prop="HasJoinGroup" label="是否入组"></el-table-column>
        <el-table-column show-overflow-tooltip
          prop="JoinGroupTime"
          label="入组日期"
          min-width="88px"
        ></el-table-column>
        <el-table-column show-overflow-tooltip
          prop="JoinTimes"
          label="入组工时"
          min-width="88px"
        ></el-table-column>
        <el-table-column show-overflow-tooltip
          prop="JoinGroupComments"
          label="入组备注"
          
        ></el-table-column>
        <el-table-column show-overflow-tooltip
          prop="EDCJoinVisitTime"
          label="EDC筛选日期"
          min-width="88px"
        ></el-table-column>
        <el-table-column show-overflow-tooltip
          prop="EDCJoinWorkTimes"
          label="EDC筛选工时"
          min-width="88px"
        ></el-table-column>
        <el-table-column show-overflow-tooltip prop="IsFailure" label="是否筛败"></el-table-column>
        <el-table-column show-overflow-tooltip
          prop="FailureTime"
          label="筛败日期"
          min-width="88px"
        ></el-table-column>
        <el-table-column show-overflow-tooltip
          prop="FailureTimes"
          label="筛败工时"
          min-width="120px"
        ></el-table-column>
        <el-table-column show-overflow-tooltip
          prop="FailureResion"
          label="筛败原因"
          
          min-width="120px"
        ></el-table-column>
        <el-table-column show-overflow-tooltip
          prop="FailureComments"
          label="筛败备注"
          
        ></el-table-column>
        <el-table-column show-overflow-tooltip
          prop="EDCOutVisitTime"
          label="EDC筛败日期"
          min-width="88px"
        ></el-table-column>
        <el-table-column show-overflow-tooltip
          prop="EDCOutWorkTimes"
          label="EDC筛败工时"
          min-width="88px"
        ></el-table-column>
        <el-table-column show-overflow-tooltip
          prop="OutTime"
          label="出组日期"
          min-width="88px"
        ></el-table-column>
        <el-table-column show-overflow-tooltip
          prop="OutResion"
          label="出组原因"
          
          min-width="120px"
        ></el-table-column>
        <el-table-column show-overflow-tooltip
          prop="OutAllowVisit"
          label="是否跟进"
        ></el-table-column>
        <el-table-column show-overflow-tooltip
          prop="OutComments"
          label="出组备注"
          
        ></el-table-column>
        <el-table-column show-overflow-tooltip
          prop="ScreenStatus"
          label="筛选状态"
          
        ></el-table-column> 
      </el-table>
    </div>
    <div>
      <el-pagination
        background
        layout="prev, pager, next, sizes,total"
        @size-change="pmpageizeChange"
        @current-change="pmchangePage"
        :page-sizes="[10, 20, 50, 100, 200, 500]"
        :page-size="tikulist.PageSize"
        :current-page.sync="tikulist.PageIndex"
        :total="totalpmcount"
      ></el-pagination>
    </div>
    <el-dialog :visible.sync="showDialog" :modal-append-to-body="false" center>
      <el-form :inline="true" :model="editKnow" class="demo-form-inline">
        <el-collapse>
          <el-collapse-item title="项目基本信息" name="1">
            <el-form size="mini" class="addProjectinput_form">
              <div class="addProjectinput_input">
                <el-form-item label="项目名称">
                  <el-input
                    readonly
                    v-model="editKnow.ProjectName"
                    placeholder="项目名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="中心名称">
                  <el-input
                    readonly
                    v-model="editKnow.CenterName"
                    placeholder="中心名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="项目经理">
                  <el-input
                    readonly
                    v-model="editKnow.PM"
                    placeholder="项目经理"
                  ></el-input>
                </el-form-item>
                <!-- <el-form-item label="项目科室">
                                    <el-input
                                        readonly
                                        v-model="editKnow.ProjectOffices"
                                        placeholder="项目科室"
                                    ></el-input>
                                </el-form-item>-->
                <el-form-item label="中心科室">
                  <el-input
                    readonly
                    v-model="editKnow.Department"
                    placeholder="中心科室"
                  ></el-input>
                </el-form-item>
                <el-form-item label="适应症">
                  <el-input
                    readonly
                    v-model="editKnow.Indications"
                    placeholder="适应症"
                  ></el-input>
                </el-form-item>
                <el-form-item label="CRC">
                  <el-input
                    readonly
                    v-model="editKnow.CRC"
                    placeholder="CRC"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="addProjectinput_input">
                <el-form-item label="中心编码">
                  <el-input
                    readonly
                    v-model="editKnow.CenterCode"
                    placeholder="中心编码"
                  ></el-input>
                </el-form-item>
                <el-form-item label="申办方">
                  <el-input
                    readonly
                    v-model="editKnow.Sponsor"
                    placeholder="申办方"
                  ></el-input>
                </el-form-item>
                <el-form-item label="项目部门">
                  <el-input
                    readonly
                    v-model="editKnow.ProjectDepartment"
                    placeholder="项目部门"
                  ></el-input>
                </el-form-item>
                <el-form-item label="项目归属">
                  <el-input
                    readonly
                    v-model="editKnow.Ownership"
                    placeholder="项目归属"
                  ></el-input>
                </el-form-item>
                <!-- <el-form-item label="适应症">
                                    <el-input
                                        readonly
                                        v-model="editKnow.Indications"
                                        placeholder="适应症"
                                    ></el-input>
                                </el-form-item>-->
                <el-form-item label="项目级别">
                  <el-input
                    readonly
                    v-model="editKnow.ProjectLevel"
                    placeholder="项目级别"
                  ></el-input>
                </el-form-item>
              </div>
            </el-form>
          </el-collapse-item>
        </el-collapse>

        <div>
          <el-form size="mini" class="addProjectinput_form">
            <div class="addProjectinput_input">
              <el-form-item label="患者简称">
                <el-input
                  v-model="editKnow.UserName"
                  placeholder="患者简称"
                ></el-input>
              </el-form-item>
              <el-form-item label="筛选日期">
                <el-date-picker
                  v-model="editKnow.ScreenDate"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="随机号">
                <el-input
                  v-model="editKnow.RandomCode"
                  placeholder="随机号"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="推荐医生">
                                <el-input v-model="editKnow.RecDoctor" placeholder="推荐医生"></el-input>
                            </el-form-item>
                            <el-form-item label="外推中心" v-if="editKnow.IsOut == '是'">
                                <el-input v-model="editKnow.OutCenter" placeholder="外推中心"></el-input>
                            </el-form-item> -->
              <el-form-item label="备注">
                <el-input
                  v-model="editKnow.Comments"
                  placeholder="备注"
                ></el-input>
              </el-form-item>

              <!-- <el-form-item label="是否筛败">
                                <el-radio-group v-model="editKnow.IsFailure" size="mini" 
                                    :disabled="tikulist.ScreenType != '筛败'"
                                >
                                    <el-radio label="是" border>是</el-radio>
                                    <el-radio label="否" border>否</el-radio>
                                </el-radio-group>
                            </el-form-item>-->
              <el-form-item label="筛败原因">
                <el-input
                  v-model="editKnow.FailureResion"
                  placeholder="筛败原因"
                  :disabled="editKnow.ScreenStatus != '筛败'"
                ></el-input>
              </el-form-item>
              <el-form-item label="筛败工时(h)">
                <el-input
                  type="number"
                  v-model="editKnow.FailureTimes"
                  placeholder="筛败工时"
                  :disabled="editKnow.ScreenStatus != '筛败'"
                ></el-input>
              </el-form-item>
              <el-form-item label="EDC筛败工时(h)">
                <el-input
                  type="number"
                  v-model="editKnow.EDCOutWorkTimes"
                  placeholder="EDC筛败工时"
                  :disabled="editKnow.ScreenStatus != '筛败'"
                ></el-input>
              </el-form-item>
              <el-form-item label="入组日期">
                <el-date-picker
                  v-model="editKnow.JoinGroupTime"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  :disabled="
                    editKnow.ScreenStatus != '出组' &&
                    editKnow.ScreenStatus != '入组'
                  "
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="EDC筛选日期">
                <el-date-picker
                  v-model="editKnow.EDCJoinVisitTime"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  :disabled="
                    editKnow.ScreenStatus != '出组' &&
                    editKnow.ScreenStatus != '入组'
                  "
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="出组日期">
                <el-date-picker
                  v-model="editKnow.OutTime"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  :disabled="editKnow.ScreenStatus != '出组'"
                ></el-date-picker>
              </el-form-item>

              <el-form-item label="是否跟进">
                <el-radio-group
                  v-model="editKnow.OutAllowVisit"
                  size="mini"
                  :disabled="editKnow.ScreenStatus != '出组'"
                >
                  <el-radio label="是" border>是</el-radio>
                  <el-radio label="否" border>否</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div class="addProjectinput_input">
              <el-form-item label="筛选号">
                <el-input
                  v-model="editKnow.ScreenCode"
                  placeholder="筛选号"
                ></el-input>
              </el-form-item>
              <el-form-item label="筛选工时(h)">
                <el-input
                  type="number"
                  v-model="editKnow.ScreenTimes"
                  placeholder="筛选工时"
                ></el-input>
              </el-form-item>
              <el-form-item label="是否招募推荐">
                <el-radio-group v-model="editKnow.IsOut" size="mini">
                  <el-radio label="是" border>是</el-radio>
                  <el-radio label="否" border>否</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- <el-form-item label="外推科室" v-if="editKnow.IsOut == '是'">
                                <el-input v-model="editKnow.OutDepartment" placeholder="外推科室"></el-input>
                            </el-form-item> -->
              <!-- <el-form-item label="是否入组">
                                <el-radio-group v-model="editKnow.HasJoinGroup" size="mini">
                                    <el-radio label="是" border>是</el-radio>
                                    <el-radio label="否" border>否</el-radio>
                                </el-radio-group>
                            </el-form-item>-->
              <el-form-item label="筛选状态">
                <el-select v-model="editKnow.ScreenStatus" placeholder="请选择">
                  <el-option
                    v-for="item in optionsKnow"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="筛败日期">
                <el-date-picker
                  v-model="editKnow.FailureTime"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  :disabled="editKnow.ScreenStatus != '筛败'"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="筛败备注">
                <el-input
                  v-model="editKnow.FailureComments"
                  placeholder="请输入筛败备注"
                  :disabled="editKnow.ScreenStatus != '筛败'"
                ></el-input>
              </el-form-item>
              <el-form-item label="EDC筛败日期">
                <el-date-picker
                  v-model="editKnow.EDCOutVisitTime"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  :disabled="editKnow.ScreenStatus != '筛败'"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="入组工时(h)">
                <el-input
                  type="number"
                  v-model="editKnow.JoinTimes"
                  placeholder="入组工时"
                  :disabled="
                    editKnow.ScreenStatus != '出组' &&
                    editKnow.ScreenStatus != '入组'
                  "
                ></el-input>
              </el-form-item>
              <el-form-item label="EDC筛选工时(h)">
                <el-input
                  type="number"
                  v-model="editKnow.EDCJoinWorkTimes"
                  placeholder="EDC筛选工时"
                  :disabled="
                    editKnow.ScreenStatus != '出组' &&
                    editKnow.ScreenStatus != '入组'
                  "
                ></el-input>
              </el-form-item>
              <el-form-item label="入组备注">
                <el-input
                  v-model="editKnow.JoinGroupComments"
                  placeholder="入组备注"
                  :disabled="
                    editKnow.ScreenStatus != '出组' &&
                    editKnow.ScreenStatus != '入组'
                  "
                ></el-input>
              </el-form-item>
              <el-form-item label="出组原因">
                <el-select
                  v-model="editKnow.OutResion"
                  placeholder="请选择"
                  :disabled="editKnow.ScreenStatus != '出组'"
                >
                  <el-option
                    v-for="item in actionsHong"
                    :key="item.CateName"
                    :label="item.CateName"
                    :value="item.CateName"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="出组备注">
                <el-input
                  v-model="editKnow.OutComments"
                  placeholder="出组备注"
                  :disabled="editKnow.ScreenStatus != '出组'"
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="submitAddProject">
          <el-button
            type="primary"
            class="submitAddProjectbtn"
            @click="editPreservation"
            >保存</el-button
          >
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script> 
import {
  getBaseUrl,
  RegionCenterTree,
  GetCRCPatientList,
  ExportCRCPatientList,
  SetCRCPatientInfo,
  GetDictValue,
  DelCRCPatientInfo,
} from "../../api/api";
import store from "../../utils/storage";
import addWatermark from '@/utils/watermark.js' // 引入水印方法
import moment from "moment";
export default {
  name: "ViewPCenterDetail", 
  data() {
    return {
      ProjectId: this.$route.query.projectId,
      CenterId: this.$route.query.centerid,
      optionsKnow: [
        {
          value: "筛选中",
          label: "筛选中",
        },
        {
          value: "筛败",
          label: "筛败",
        },
        {
          value: "入组",
          label: "入组",
        },
        {
          value: "出组",
          label: "出组",
        },
      ],
      treeDatas: [],
      PropsCenterKey: {
        children: "Children",
        label: "RegionName",
        value: "RegionName",
        emitPath: false,
      },
      beginDate: [],
      beginDate1: [],
      beginDate2: [],
      // //日历快捷项
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      cityCascaders: [], //地区树

      totalpmcount: 0, //总数
      hostUrl: getBaseUrl(), 
      loadingUp: false, //选择文件  批量导入
      tikudata: [],
      tikulist: {
        Id: 0,
        UserName: "",
        ProjectName: "",
        CenterName: "",
        RegionName: "",
        ScreenType: "",
        BeginDate: "",
        EndDate: "",
        JoinBeginDate: "",
        JoinEndDate: "",
        FailureBeginDate: "",
        FailureEndDate: "",
        sw1: "",
        sw2: "",
        sw3: "",
        PageIndex: 0,
        PageSize: 20,
        Skip: 0,
        RequetUrl: "",
      },
    
      showDialog: false,
      centerModifyProvinceName: [],
      defaultPropsCenter: {
        children: "Children",
        label: "RegionName",
        value: "RegionId",
        emitPath: false,
      },
      defaultPropsCenterKey: {
        children: "Children",
        label: "RegionName",
        value: "RegionName",
        emitPath: false,
      },
      centerModifyKey: 0,
      editKnow: {
        Id: 0,
        ProjectName: "",
        CenterCode: "",
        CenterName: "",
        Sponsor: "",
        PM: "",
        ProjectDepartment: "",
        ProjectOffices: "",
        ProjectType: "",
        Indications: "",
        Ownership: "",
        CRC: "",
        ProjectLevel: "",
        UserName: "",
        ScreenCode: "",
        ScreenDate: "",
        ScreenTimes: 0,
        RandomCode: "",
        Department: "",
        RecDoctor: "",
        IsOut: "",
        OutCenter: "",
        OutDepartment: "",
        Comments: "",
        HasJoinGroup: 0,
        JoinGroupTime: "",
        JoinGroupComments: "",
        IsFailure: "",
        FailureTime: "",
        FailureResion: "",
        FailureComments: "",
        OutTime: "",
        OutResion: "",
        OutComments: "",
        OutAllowVisit: 0,
        ScreenStatus: "",
      },
      actionsHong: [],
      tableHeight: 0, //表格的高 
      exportLoading: false,
    };
  }, 
 
  mounted() { 
    // 添加水印
    const userInfo = JSON.parse(localStorage.getItem("cur-user-info"));
    if(userInfo.showWatermark) {
      const time = moment().format("YYYY-MM-DD");
      addWatermark({
        content: userInfo.UserName + time,
      });
    }
    
    this.search(1);
    this.getDictValue();
    // 树列表开始
    RegionCenterTree().then((res) => {
      this.treeDatas = res.data.Data;
    });
  },
  methods: {
    // 知情时间
    BEdate(date) {
      if (date) {
        this.tikulist.BeginDate = this.formatDate(date[0]);
        this.tikulist.EndDate = this.formatDate(date[1]);
      } else {
        this.tikulist.BeginDate = "";
        this.tikulist.EndDate = "";
      }
    },
    // 入组时间
    dateGroup(date) {
      if (date) {
        this.tikulist.JoinBeginDate = this.formatDate(date[0]);
        this.tikulist.JoinEndDate = this.formatDate(date[1]);
      } else {
        this.tikulist.JoinBeginDate = "";
        this.tikulist.JoinEndDate = "";
      }
    },
    // 筛败时间
    dateSieve(date) {
      if (date) {
        this.tikulist.FailureBeginDate = this.formatDate(date[0]);
        this.tikulist.FailureEndDate = this.formatDate(date[1]);
      } else {
        this.tikulist.FailureBeginDate = "";
        this.tikulist.FailureEndDate = "";
      }
    },
    
    // 获取列表
    search(num) {
      this.loadingUp = true;
      if (this.tikulist.RegionName == null) {
        this.tikulist.RegionName = "";
      }
      if (num != 1) {
        this.tikulist.PageIndex = 0;
      }
      this.tikulist.sw3=this.ProjectId+','+this.CenterId;
      GetCRCPatientList(this.tikulist).then((res) => {
        if (res.data.Code != 1) this.$message.error(res.data.Msg);
        this.tikudata = res.data.Data;
        this.totalpmcount = res.data.ExtData;
        this.loadingUp = false;
      });
    },

    // 设置分页
    pmchangePage(size) {
      this.tikulist.PageIndex = size;
      this.search(1);
    },
    // 设置页数
    pmpageizeChange(size) {
      this.tikulist.PageSize = size;
      this.search();
    },
    IsHasShowBtn(tp) {
      var exists = this.curPermission.filter((p) => p.Code === tp);
      return exists.length > 0;
    },
    //导出
    exportCRCCenterList() {
      this.exportLoading = true;
      ExportCRCPatientList(this.tikulist).then((res) => {
        if (res.data.Code != 1) return this.$message.error(res.data.Msg);
        if (res.data.Data) {
          window.open(this.hostUrl + res.data.Data);
          this.exportLoading = false;
        }
      });
    },
    // 日期转换
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    //编辑
    knowClick(val) {
      this.editKnow = val;
      this.showDialog = true;
    },
    // 保存修改
    editPreservation() {
      this.$confirm("是否提交修改?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.editKnow.IsOut == "否") {
            this.editKnow.OutDepartment = "";
            this.editKnow.OutCenter = "";
          }
          if (this.editKnow.ScreenStatus == "入组") {
            if (
              this.editKnow.JoinGroupTime == null ||
              this.editKnow.JoinGroupTime == ""
            ) {
              return this.$message.error("入组日期不能为空");
            }
            // if (this.editKnow.JoinGroupTime == null || this.editKnow.JoinGroupTime == '') {
            //     return this.$message.error("入组日期不能为空")
            // }
            this.editKnow.FailureTime = "";
            this.editKnow.FailureComments = "";
            this.editKnow.OutResion = "";
            this.editKnow.OutComments = "";
            this.editKnow.OutTime = "";
            this.editKnow.OutAllowVisit = "";
            this.editKnow.FailureResion = "";
            this.editKnow.FailureTimes = 0;

            this.editKnow.EDCOutVisitTime = "";
            this.editKnow.EDCOutWorkTimes = 0;

          } else if (this.editKnow.ScreenStatus == "出组") {
            if (
              this.editKnow.JoinGroupTime == null ||
              this.editKnow.JoinGroupTime == ""
            ) {
              return this.$message.error("入组日期不能为空");
            }
            if (this.editKnow.OutTime == null || this.editKnow.OutTime == "") {
              return this.$message.error("出组日期不能为空");
            }
            if (this.editKnow.OutResion == "") {
              return this.$message.error("出组原因不能为空");
            }
            this.editKnow.FailureTime = "";
            this.editKnow.FailureComments = "";
            this.editKnow.FailureResion = "";
            this.editKnow.FailureTimes = 0;
          } else if (this.editKnow.ScreenStatus == "筛败") {
            if (
              this.editKnow.FailureTime == null ||
              this.editKnow.FailureTime == ""
            ) {
              return this.$message.error("筛败日期不能为空");
            }
            this.editKnow.OutResion = "";
            this.editKnow.OutComments = "";
            this.editKnow.OutTime = "";
            this.editKnow.OutAllowVisit = "";
            this.editKnow.JoinGroupTime = "";
            this.editKnow.JoinGroupComments = "";
            this.editKnow.JoinTimes = 0;

            this.editKnow.EDCJoinVisitTime = "";
            this.editKnow.EDCJoinWorkTimes = 0;

          } else if (this.editKnow.ScreenStatus == "筛选中") {
            this.editKnow.OutResion = "";
            this.editKnow.OutComments = "";
            this.editKnow.OutTime = "";
            this.editKnow.OutAllowVisit = "";
            this.editKnow.JoinGroupTime = "";
            this.editKnow.JoinGroupComments = "";
            this.editKnow.JoinTimes = 0;
            this.editKnow.FailureTime = "";
            this.editKnow.FailureComments = "";
            this.editKnow.FailureResion = "";
            this.editKnow.FailureTimes = 0;
          }

          SetCRCPatientInfo(this.editKnow).then((res) => {
            if (res.data.Code != 1) return this.$message.error(res.data.Msg);
            if (res.data.Data) {
              this.$message.success("修改成功");
              this.showDialog = false;
              this.search(1);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消提交",
          });
        });
    },
    //出组原因字典
    getDictValue() {
      this.actionsHong = [];
      let params = {
        PCode: "bus_dict_outgroup",
      };
      GetDictValue(params).then((res) => {
        this.loading = false;
        if (res.data.Code != 1) return this.$message.error(res.data.Message);
        this.actionsHong = res.data.Data;
      });
    },
     
  },
};
</script>

<style lang="scss" scoped>
.marg {
  margin-top: 10px;
}
.table {
  margin-bottom: 10px;
}
.el-dialog .el-select,
.el-dialog .el-cascader {
  width: 180px;
}
.el-dialog .el-form-item__content > .el-input {
  width: 180px;
}
.froms {
  display: flex;
  justify-content: space-around;
}
.froms /deep/ .el-form-item {
  margin-bottom: 5px;
}
.froms /deep/ .el-input__inner {
  height: 30px;
  line-height: 30px;
}
.dialog-footer /deep/ .el-button {
  padding: 5px 20px;
}
.marg {
  margin-bottom: 20px;
}
.marg /deep/ .el-input__inner {
  height: 30px;
  line-height: 30px;
}
.marg /deep/ .el-range__icon {
  line-height: 24px;
}
.marg /deep/ .el-range-separator {
  line-height: 24px;
}
.margBtn {
  margin-left: 20px;
}
.el-date-editor--daterange.el-input__inner {
  width: 230px;
}
.addProjectinput_form {
  display: flex;
  justify-content: space-between;
  width: 600px;
  margin: 10px auto;
  /deep/ .el-radio--mini.is-bordered {
    padding: 6px 19px 0 15px;
    border-radius: 3px;
    height: 26px;
  }
}
.addProjectinput_input {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.submitAddProject {
  width: 194px;
  height: 40px;
  margin: 0 auto;
}
.submitAddProjectbtn {
  width: 194px;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/centeruser/ViewPCenterDetail.vue